"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Http Request',
    description: 'Send an arbitrary HTTP/S request',
});
//# sourceMappingURL=http-request.js.map